// src/HomePage/Game/FolkGame/Caro/CaroBoard.js
// FIXED: thêm prop gameEnded để ẩn last-move highlight khi ván kết thúc.
//        thêm ARIA label + aria-disabled cho accessibility.
import React, { useMemo } from 'react';
import { normalizeBoard } from './CaroLogic';
import './CaroBoard.css';

const CaroBoard = ({
  board,
  onCellClick,
  disabled,
  winningLine,
  lastMove,
  gameEnded = false
}) => {
  const safeBoard = Array.isArray(board) ? board : normalizeBoard(board);

  // Memo lại set ô thắng để check nhanh O(1)
  const winningSet = useMemo(() => {
    if (!Array.isArray(winningLine)) return new Set();
    return new Set(winningLine.map(([r, c]) => `${r}-${c}`));
  }, [winningLine]);

  const isWinningCell = (r, c) => winningSet.has(`${r}-${c}`);

  const isLastMove = (r, c) => {
    // FIX #8: khi ván kết thúc, ẩn last-move highlight (chỉ giữ winning line)
    if (gameEnded) return false;
    return lastMove && lastMove.r === r && lastMove.c === c;
  };

  return (
    <div className="caro-board-wrapper" role="grid" aria-label="Bàn cờ caro 15x15">
      <div className="caro-board-grid">
        {safeBoard.map((row, rIdx) => (
          <div key={rIdx} className="caro-row" role="row">
            {Array.isArray(row) &&
              row.map((cell, cIdx) => {
                const isWin = isWinningCell(rIdx, cIdx);
                const isLast = isLastMove(rIdx, cIdx);
                const isEmpty = cell === null;
                const cellDisabled = disabled || !isEmpty;

                const ariaLabel = isEmpty
                  ? `Hàng ${rIdx + 1} cột ${cIdx + 1}, ô trống`
                  : `Hàng ${rIdx + 1} cột ${cIdx + 1}, quân ${cell}${isWin ? ', ô thắng' : ''}${isLast ? ', nước vừa đi' : ''}`;

                return (
                  <button
                    key={`${rIdx}-${cIdx}`}
                    type="button"
                    className={`caro-cell ${cell ? `filled ${cell.toLowerCase()}` : ''} ${isWin ? 'winning' : ''} ${isLast ? 'last-move' : ''}`}
                    disabled={cellDisabled}
                    onClick={() => onCellClick(rIdx, cIdx)}
                    role="gridcell"
                    aria-label={ariaLabel}
                    aria-disabled={cellDisabled}
                  >
                    {cell === 'X' && <span className="caro-x" aria-hidden="true">✕</span>}
                    {cell === 'O' && <span className="caro-o" aria-hidden="true">◯</span>}
                  </button>
                );
              })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaroBoard;
